import React from 'react';
import {get} from 'lodash';
import className from 'classnames';

class OverflowH extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  $text = React.createRef()

  state = {
    isOverflow: false,
  };

  componentDidMount = () => {
    if (get(this.$text, 'current.scrollHeight') > get(this.$text, 'current.clientHeight')) {
      this.setState({
        isOverflow: true,
      })
    }
  }

  render = () => {
    return (
      <div
        className={className('OverflowH', {
          'OverflowH--control-width': this.props.controlWidth,
        })}
      >
        <div className='OverflowH__wrapper' ref={this.$text}>
          {this.props.text}
        </div>

        {this.state.isOverflow &&
          <div className='DotTooltip DotTooltip--right'>
            <a className='OverflowH__a'>
              <div className='DotTooltip__a__panel'>
                {get(this.props, 'text')}
              </div>
            </a>
          </div>
        }
      </div>
    );
  }
}

export default OverflowH;
